(() => {
  const root = document.querySelector('.dg-horl-page');

  if (!root) {
    return;
  }

  root.querySelectorAll('.dg-horl-product-form').forEach((form) => {
    form.addEventListener('submit', () => {
      const button = form.querySelector('.dg-horl-atc');

      if (!button || button.disabled) {
        return;
      }

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding...';
    });
  });

  root.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const targetId = link.getAttribute('href');

      if (!targetId || targetId === '#') {
        return;
      }

      const target = document.querySelector(targetId);

      if (!target) {
        return;
      }

      event.preventDefault();

      target.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', targetId);
      }
    });
  });
})();